import { useMutation } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsFavorite } from 'reporting-data/report/reportGetters';
// @ts-expect-error untyped import
import { useFavoriteReports } from '../../data/hooks/useFavoriteReports';
// @ts-expect-error untyped import
import { ADD_REPORT_TO_FAVORITES } from '../../data/requests/favoriteAssets';
// @ts-expect-error untyped import
import { FETCH_FAVORITE_REPORTS } from '../../data/requests/favoriteAssets';
// @ts-expect-error untyped import
import { REMOVE_REPORT_FROM_FAVORITES } from '../../data/requests/favoriteAssets';
import { ACTION_ASSET_TYPES } from '../../constants/actionAssetTypes';
import FavoriteAssetButton, { showErrorAlert } from './FavoriteAssetButton';
import useAddFavoriteReportProblem from './useFavoriteReportProblem';
import { jsx as _jsx } from "react/jsx-runtime";
const FavoriteReportButton = ({
  actionLocation,
  appUsageTracker,
  disabledMessage: appDisabledMessage,
  onAddFavoriteSuccess = () => {},
  onRemoveFavoriteSuccess = () => {},
  report
}) => {
  const {
    data: favoriteReports,
    loading
  } = useFavoriteReports();
  const {
    disabledMessage: libDisabledMessage
  } = useAddFavoriteReportProblem({
    report
  });
  const reportId = report.get('id');
  const [addFavoriteMutation] = useMutation(ADD_REPORT_TO_FAVORITES, {
    variables: {
      reportId
    },
    onCompleted: () => {
      onAddFavoriteSuccess(reportId);
    },
    onError: err => {
      showErrorAlert('reporting-action-components.actions.favoriteAssets.report.add.error');
      throw err;
    },
    refetchQueries: () => {
      return [{
        query: FETCH_FAVORITE_REPORTS
      }];
    }
  });
  const [removeFavoriteMutation] = useMutation(REMOVE_REPORT_FROM_FAVORITES, {
    variables: {
      reportId
    },
    onCompleted: () => {
      onRemoveFavoriteSuccess(reportId);
    },
    onError: err => {
      showErrorAlert('reporting-action-components.actions.favoriteAssets.report.remove.error');
      throw err;
    },
    refetchQueries: () => {
      return [{
        query: FETCH_FAVORITE_REPORTS
      }];
    }
  });
  if (!reportId) {
    return null;
  }
  const isFavorite = loading && getIsFavorite(report) || !!favoriteReports.find(favoriteAsset => favoriteAsset.get('objectId') === reportId);
  const disabledMessage = appDisabledMessage || libDisabledMessage;
  const enabledMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: isFavorite ? 'reporting-action-components.actions.favoriteAssets.report.remove.tooltip' : 'reporting-action-components.actions.favoriteAssets.report.add.tooltip'
  });
  return /*#__PURE__*/_jsx(FavoriteAssetButton, {
    actionLocation: actionLocation,
    appUsageTracker: appUsageTracker,
    assetType: ACTION_ASSET_TYPES.REPORT,
    disabledMessage: disabledMessage,
    enabledMessage: enabledMessage,
    onAddFavorite: addFavoriteMutation,
    onRemoveFavorite: removeFavoriteMutation,
    isFavorite: isFavorite
  });
};
export default FavoriteReportButton;